import { render, staticRenderFns } from "./MarketingPoints.vue?vue&type=template&id=9ec99210&"
import script from "./MarketingPoints.vue?vue&type=script&lang=js&"
export * from "./MarketingPoints.vue?vue&type=script&lang=js&"
import style0 from "./MarketingPoints.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports